export enum SessionClaimStatus {
  Unclaimed = 'Unclaimed',
  Claimed = 'Yes',
  NotReady = 'Not ready',
}

// Set VITE_TEST=true to use the fixed billing week during tests.
export const selectedDateForBillingWeekly =
  process.env.VITE_TEST === 'true' ? new Date(2024, 2, 11) : new Date();

// Set VITE_DISABLE_BILLING_LAG_WEEKS=true to include the current billing week.
export const billingLagInWeeks = process.env.VITE_DISABLE_BILLING_LAG_WEEKS === 'true' ? 0 : 3;

export const BILLING_HISTORY_DEFAULT_DURATION_SEARCH_DAYS = 7;

export enum ServiceCodes {
  AssessmentCode = '97151',
  AssistingAssessmentCode = '97152',
  SessionProcedureCode = '97153',
  ClientSNProcedureCode = '97155',
  ParentSNProcedureCode = '97156',
  GroupSNProcedureCode = '97157',
}

export enum HCPCSServiceCodes {
  AssessmentCode = 'H0031',
  AssistingAssessmentCode = 'H0032',
  SessionProcedureCode = 'H2019',
  ClientSNProcedureCode = 'H2012',
  ParentSNProcedureCode = 'S5110',
  GroupSNProcedureCode = 'S5111',
}

// Enum to explicitly allowing serviceCodes to build claims,
// If a new service code is introduced in system which is not allowed to build claims,
// then this enum will help control new service code to be shown on claim build page.
export enum AllowedServiceCodesToBuildClaim {
  AssessmentCode = '97151',
  AssistingAssessmentCode = '97152',
  SessionProcedureCode = '97153',
  ClientSNProcedureCode = '97155',
  ParentSNProcedureCode = '97156',
  GroupSNProcedureCode = '97157',
}

export const BAY_EXEMPT_FROM_CLAIMS = ['1'] as const;

/** Gate for enabling relaxed claim validations in preview/create payloads (frontend-only). */
export const RELAX_CLAIM_VALIDATIONS_PASSWORD = '1UZgH5DnxaSF&vhXH7XkXa*B';

export const RELAX_CLAIM_VALIDATIONS_PASSWORD_VERIFIED_MESSAGE = 'Password verified';

export const RELAX_CLAIM_VALIDATIONS_PASSWORD_MISMATCH_MESSAGE = 'Password does not match';
